import { Helmet } from 'react-helmet-async';

type TMetaTitle = {
  children: string | string[];
}

const MetaTitle = (props: TMetaTitle) => {

  const title = Array.isArray(props.children) ? props.children.join('') : props.children;

  return <Helmet>
    <title>{title}</title>
  </Helmet>
}

export default MetaTitle;